import { createSelector } from "@ngrx/store";

import * as fromRoot from "#core/router-store";
import { Asset } from "@carnegie-learning/cure-types";
import * as fromFeature from "../reducers";
import * as fromAssets from "../reducers/assets.reducer";

export const getAssetsState = createSelector(
    fromFeature.getCreateModuleState,
    (state: fromFeature.CreateState) => state.assets
);

export const getAssetsEntities = createSelector(
    getAssetsState,
    fromAssets.getAssetsEntities
);

export const getAssets = createSelector(getAssetsEntities, (entities) => {
    return Array.from(entities.values());
});

export const getAssetsFromIds = createSelector(
    getAssetsEntities,
    (entities) => {
        return Array.from(entities.values());
    }
);

export const getSelectedAsset = createSelector(
    // asset state (list of all assets)
    getAssetsEntities,
    getAssetsState,
    // url state (current url)
    fromRoot.getRouterState,
    // returns the asset based off url param
    (entities, assetState, router): Asset | null => {
        if (router) {
            const entity = entities.get(router.state.params.assetId);
            if (entity !== undefined) {
                return router.state && entity;
            } else {
                return router.state && fromAssets.getSelectedAsset(assetState);
            }
        } else {
            return null;
        }
    }
);

export const getSelectedAssetLoading = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssetLoading
);

export const getSelectedAssetLoaded = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssetLoaded
);

export const getSelectedAssets = createSelector(
    getAssetsState,
    fromAssets.getSelectedAssets
);

export const getAssetsLoading = createSelector(
    getAssetsState,
    fromAssets.getAssetsLoading
);

export const getAssetsLoaded = createSelector(
    getAssetsState,
    fromAssets.getAssetsLoaded
);

export const getAssetPaginationParams = createSelector(
    getAssetsState,
    fromAssets.getAssetPaginationParams
);

export const getRawAssetsResponse = createSelector(
    getAssetsState,
    fromAssets.getRawAssetsResponse
);

export const getAssetsTab = createSelector(
    getAssetsState,
    fromAssets.getAssetsTab
);

export const getDistinctFilterDefinitions = createSelector(
    getAssetsState,
    fromAssets.getDistinctFilterDefinitions
);

export const getDistinctPublishedByFilter = createSelector(
    getAssetsState,
    fromAssets.getDistinctPublishedByFilter
);

export const getAlgoliaSearchResult = createSelector(
    getAssetsState,
    fromAssets.getAlgoliaSearchResult
);

export const getClonedAsset = createSelector(
    getAssetsState,
    fromAssets.getClonedAsset
);

export const getUpdatedBundle = createSelector(
    getAssetsState,
    fromAssets.getUpdatedBundle
);
